import { Box } from '@mui/material';
export type LoaderProps = {
  height?: string;
};
export const Loader = ({ height }: LoaderProps) => {
  return <Box component={'img'} sx={{ maxHeight: height ?? '6rem' }} src="/images/loading.svg"></Box>;
};
